export default __webpack_public_path__ + "static/Jabrille_Lotus_Trading-b777c9f9f9d299f07897a7992baef6c7.mp4";